//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('statBubble', {
    bindings: {
      title: '@',
      icon: '@',
      tt: '@',
      formatter: '=',
      decorate: '=',
      data: '=',
      ttPlacement: '@?',
    },
    template: require('@partials/stat-bubble.html'),
    transclude: {
      secondaryData: '?secondaryData',
    },
    controller: [function() {
      const self = this;
      self.$onInit = () => {
        const fullWrapperEl = angular.element('#full-wrapper')[0];
        self.isFullWrapper = !!fullWrapperEl;
      };
    }],
  });
})();
